/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='menuBar_portrait'>
        <Image position={[-360, 0]} scale={[2160, undefined]} name='bg' src='menu_bg_wide_pm' />
        <Text
            position={[280, 500]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 150,
                fontStyle: 'normal',
                fill: '#9B9B9B',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1600}
            name='label'
            localeTextID=''
            text='SOUNDS SETTINGS'
        />
    </Sprite>
);
